



















































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import AccountDepositCoolingOffSettings from '@/models/Accounts/DepositAccounts/Settings/AccountDepositCoolingOffSettings';
import AccountDepositCoolingOffSettingsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/CoolingOff/AccountDepositCoolingOffSettingsEditDialog.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountDepositCoolingOffSettingsRead', components: { AccountDepositCoolingOffSettingsEditDialog }  })
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountDepositCoolingOffSettings;

    async deleteDepositCoolingOffAccountSettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await DepositAccountSettingsModule.deleteDepositCoolingOffSettings();
        }
    }

}
